import { IncomingHttpHeaders, IncomingMessage, ServerResponse } from 'node:http'
import { convertUrlToPath, sanitizeDynamicPaths } from './processHttpPaths'

export const DATADOG_LOG_META_KEY = 'meta'
export const DATADOG_SERVICE_NAME = 'reward-platform'

export type DatadogLogErrorContext = {
  message: string
  stack?: string
  code?: string
  description: string
  httpStatus?: number
  [key: string]: any
}

export type DatadogLogMetaContext = {
  partner: 'EI' | 'BA' | 'IB'
  platformType: 'avios' | 'whitelabel'
  correlationId?: string | null
  [key: string]: any
}

export type DatadogLogHttpContext = {
  method?: string
  status_code?: number
  url?: string
}

type DatadogLogBaseContext = {
  dd: {
    service: typeof DATADOG_SERVICE_NAME
    env: string
    version: string
  }
  service: typeof DATADOG_SERVICE_NAME
  timestamp: number
  [key: string]: any
}

export type DatadogLogContext = DatadogLogBaseContext & {
  [DATADOG_LOG_META_KEY]: DatadogLogMetaContext
  level?: 'info' | 'warn' | 'error' | 'critical'
  http?: DatadogLogHttpContext
  error?: DatadogLogErrorContext
  headers?: IncomingHttpHeaders
}

export const createDatadogMetaContext = (meta: DatadogLogMetaContext) => ({
  [DATADOG_LOG_META_KEY]: meta,
})

export const getDatadogLoggerBaseMeta = (
  obj: { [key: string]: any } = {}
): DatadogLogBaseContext => ({
  dd: {
    service: DATADOG_SERVICE_NAME,
    env: String(process.env.NODE_ENV),
    version: '1.0',
  },
  service: DATADOG_SERVICE_NAME,
  timestamp: Date.now(),
  ...obj,
})

export const createServerLoggerMeta = (
  req?: IncomingMessage,
  res?: ServerResponse,
  additionalMeta?: Record<string, any> | null
): DatadogLogContext => ({
  ...getDatadogLoggerBaseMeta(),
  ...createDatadogMetaContext({
    partner: req?.headers['x-partner'],
    opCo: req?.headers['x-partner'],
    platformType: req?.headers['x-platform-type'],
    correlationId: req?.headers['x-correlation-id'],
    searchEngine: req?.headers['x-search-engine'],
    req: {
      httpVersion: req?.httpVersion,
      method: req?.method,
      url: req?.url,
      path: req?.url ? convertUrlToPath(req.url) : undefined,
    },
    res: {
      statusCode: res?.statusCode,
    },
    sanitizedPath: req?.url ? sanitizeDynamicPaths(convertUrlToPath(req.url)) : undefined,
    ...additionalMeta,
  } as DatadogLogMetaContext),
})
